import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import './DashboardLayout.css';

const DashboardLayout = ({ children, title }) => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const user = useAuthStore((state) => state.user);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="dashboard-wrapper">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1 className="logo">MercadoPrestamos</h1>
        </div>
        <nav className="sidebar-menu">
          <ul>
            <li>
              <Link to="/dashboard" className="menu-item">
                <i className="icon">📊</i> Dashboard
              </Link>
            </li>
            <li>
              <Link to="/loans" className="menu-item">
                <i className="icon">💰</i> Préstamos
              </Link>
            </li>
            <li>
              <Link to="/cards" className="menu-item">
                <i className="icon">💳</i> Tarjetas
              </Link>
            </li>
            <li>
              <Link to="/leads" className="menu-item">
                <i className="icon">📋</i> Leads
              </Link>
            </li>
            <li>
              <Link to="/content" className="menu-item">
                <i className="icon">📝</i> Contenido
              </Link>
            </li>
            <li>
              <Link to="/settings" className="menu-item">
                <i className="icon">⚙️</i> Configuración
              </Link>
            </li>
          </ul>
        </nav>
      </aside>

      {/* Main Content */}
      <div className="main-content">
        {/* Top Bar */}
        <div className="top-bar">
          <div className="top-bar-content">
            <h2>{title}</h2>
            <div className="user-menu">
              <span className="user-name">
                {user?.firstName} {user?.lastName}
              </span>
              <button onClick={handleLogout} className="btn-logout">
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="content-area">{children}</div>
      </div>
    </div>
  );
};

export default DashboardLayout;
